// ハンバーガーメニュー -----
document.addEventListener("DOMContentLoaded", () => {
	const ham = document.querySelector(".header__ham");
	const drawer = document.querySelector(".headerDrawer");
	const firstLink = drawer?.querySelector(".headerDrawer__link");
	let isOpen = false;
	let scrollPos = 0;

	if (!ham || !drawer) return;

	function lockScroll() {
		scrollPos = window.scrollY || window.pageYOffset;
		Object.assign(document.body.style, {
			position: "fixed",
			top: `-${scrollPos}px`,
			left: "0",
			right: "0",
			width: "100%",
		});
	}

	function unlockScroll() {
		const html = document.documentElement;
		const prev = html.style.scrollBehavior;

		html.style.scrollBehavior = "auto";
		Object.assign(document.body.style, {
			position: "",
			top: "",
			left: "",
			right: "",
			width: "",
		});
		window.scrollTo({ top: scrollPos, left: 0, behavior: "auto" });

		requestAnimationFrame(() => {
			html.style.scrollBehavior = prev;
		});
	}

	function openMenu() {
		if (isOpen) return;
		isOpen = true;

		lockScroll();

		ham.classList.add("is-active");
		ham.setAttribute("aria-expanded", "true");

		drawer.removeAttribute("hidden");

		void drawer.offsetWidth;

		requestAnimationFrame(() => {
			drawer.classList.add("is-active");
			drawer.dataset.open = "true";
			firstLink?.focus();
		});
	}

	function closeMenu() {
		if (!isOpen) return;
		isOpen = false;

		ham.classList.remove("is-active");
		ham.setAttribute("aria-expanded", "false");
		drawer.classList.remove("is-active");
		drawer.dataset.open = "false";

		const onEnd = (e) => {
			if (e.target !== drawer) return;
			drawer.setAttribute("hidden", "");
			drawer.removeEventListener("transitionend", onEnd);
		};
		drawer.addEventListener("transitionend", onEnd);

		unlockScroll();

		ham.focus();
	}

	function toggleMenu() {
		isOpen ? closeMenu() : openMenu();
	}

	ham.addEventListener("click", toggleMenu);

	// メニュー内リンクで閉じる
	drawer.addEventListener("click", (e) => {
		if (e.target.closest(".headerDrawer__link")) closeMenu();
	});

	// 外側クリックで閉じる（ドロワー背景をクリックしたとき）
	document.addEventListener("click", (e) => {
		if (isOpen && !e.target.closest(".header__ham") && !e.target.closest(".headerDrawer")) {
			closeMenu();
		}
	});

	// Escキーで閉じる
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && isOpen) closeMenu();
	});

	// 初期状態
	ham.setAttribute("aria-expanded", "false");
});

// footer Pagetop
document.addEventListener("DOMContentLoaded", () => {
	const btn = document.querySelector(".footer__pagetop");

	if (!btn) return;

	btn.addEventListener("click", (e) => {
		e.preventDefault();
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});
});

// ソリューション ホバー -----
const items = document.querySelectorAll(".solutionNav__link");
const images = document.querySelectorAll(".solutionNav__img.u-show--pc img");

items.forEach((item, index) => {
	const activateImage = () => {
		images.forEach((img) => img.classList.remove("is-active"));
		images[index].classList.add("is-active");
	};

	item.addEventListener("mouseenter", activateImage);

	item.addEventListener("focus", activateImage);
});

// ソリューション アニメーションクラス -----
document.addEventListener("DOMContentLoaded", () => {
	const list = document.querySelector(".solutionNav__list");
	const items = document.querySelectorAll(".solutionNav__item");

	function toggleFadeTrigger() {
		const isSp = window.innerWidth <= 768;

		if (isSp) {
			list?.classList.remove("js-fadeTrigger");
			items.forEach((item) => item.classList.add("js-fadeTrigger"));
		} else {
			list?.classList.add("js-fadeTrigger");
			items.forEach((item) => item.classList.remove("js-fadeTrigger"));
		}
	}

	// 最初の判定
	toggleFadeTrigger();

	// 画面サイズ変更時にも切り替え
	window.addEventListener("resize", toggleFadeTrigger);
});

// 導入事例 課題・成果高さ -----
function CaseHeights() {
	const breakpoint = 769; // PC判定ブレークポイント

	// 高さリセット
	document.querySelectorAll(".caseList__col, .caseList__desc").forEach((el) => {
		el.style.height = "auto";
	});

	if (window.innerWidth >= breakpoint) {
		// --- ① 課題・成果 ---
		[".caseList__col--issue", ".caseList__col--result"].forEach((selector) => {
			const cols = document.querySelectorAll(selector);
			let maxHeight = 0;
			cols.forEach((col) => {
				if (col.offsetHeight > maxHeight) maxHeight = col.offsetHeight;
			});
			cols.forEach((col) => (col.style.height = `${maxHeight}px`));
		});

		// --- ② 説明文 ---
		const descs = document.querySelectorAll(".caseList__desc");
		let maxDescHeight = 0;
		descs.forEach((desc) => {
			if (desc.offsetHeight > maxDescHeight) maxDescHeight = desc.offsetHeight;
		});
		descs.forEach((desc) => (desc.style.height = `${maxDescHeight}px`));
	}
}

window.addEventListener("load", CaseHeights);
window.addEventListener("resize", () => {
	clearTimeout(window.caseResizeTimer);
	window.caseResizeTimer = setTimeout(CaseHeights, 150);
});
